<template>
  <form class="step step-publication" @submit.prevent="submit">
    <div class="step-row">
      <div class="step-row__title text_xl_large">{{ i18n.sale_publication_text_1() }}</div>
      <br>
      <div class="step-row__title text_medium">{{ i18n.sale_publication_text_2() }}</div>
      <div class="step-row__title text_medium">{{ i18n.sale_publication_text_3() }}</div>
    </div>
    <div class="btn-wrap column">
      <md-button type="submit" class="btn md-primary" :disabled="isPending">
        {{ i18n.sale_publication_confirm() }}
      </md-button>
      <md-button @click="stepBack()" class="simple-link arrow_back">
        {{ i18n.lbl_go_back_2() }}
      </md-button>
    </div>
  </form>
</template>

<script>
  import StepMixin from './step.mixin'
  import config from '@conf'
  import { ErrorHandler } from '@js/errors/error_handler'
  import { commonEvents } from '@js/events/common_events'
  import { i18n } from '@js/i18n'

  export default {
    name: 'StepPublication',
    mixins: [StepMixin],
    data: _ => ({
      i18n,
      config,
      isPending: false
    }),

    async created () {
    },

    computed: {
    },

    methods: {
      stepBack () {
        this.$emit(commonEvents.saleStepBack)
      },
      async submit () {
        this.isPending = true
        if (!await this.isValid()) return
        this.disable()
        try {
          this.$emit(commonEvents.saleEditEndEvent, {
            form: this.form
          })
        } catch (error) {
          ErrorHandler.processUnexpected(error)
        }
        this.isPending = false
        this.enable()
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../steps/step";
</style>



// WEBPACK FOOTER //
// src/vue/app/saleCreation/steps/Step.Publication.vue